import "../styles/aboutme.css"

export default function Aboutme() {
    return (
    <section className="py-13 px-8 max-w-4xl mx-auto">
    <div className="bg-stone-700/30 backdrop-blur-sm border border-stone-600/30 rounded-lg p-8">
        <h2 className="text-center text-amber-200/80 mb-8 uppercase tracking-wider">About Me</h2>
        <p className="text-stone-300 leading-relaxed text-center">
            Hello! I'm a passionate software developer from Oulu, Finland. I specialize in web development. I believe the best way to grow and learn is through hands-on experience, which is why I love exploring new projects and technologies. Whether it's a full-stack web app, a data visualization tool, or an experimental side project, I'm always eager to bring ideas to life. My curiosity drives me to constantly learn new technologies. Right now, I am looking for new opportunities to grow as a professional in the field of software development. Feel free to contact me, as I am eager to start the next chapter!
        </p>
    </div>
    </section>
  );
};